import {Accordion, AccordionDetails, AccordionSummary, Card, Grid} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {SwitchSegmentedYesNo, TextBox} from '../../../Core/UI';
import {DatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {SelectInputElement} from '../Components/SelectInputElement';
import React from 'react';
import {observer} from 'mobx-react-lite';
import {HealthQuestionsProps} from './HealthQuestionsList';
import {Parameter} from '../../../Core/mobx/ParameterStore/ParameterStore';
import {fieldOptions} from '../../../Core/mobx/ParameterStore/HealthXref';

const Cholesterol = observer(({counter, valueChanged, parameters, coreQuestions}: HealthQuestionsProps) => {
    return (
        <Accordion style={{width: '100%'}} TransitionProps={{unmountOnExit: true}}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={'cholesterol-content'}
                id={'cholesterol-header'}
            >
                <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
                    <div>Cholesterol</div>
                    <div>{counter('cholesterol')}</div>
                </div>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container>
                    <Grid key="params" container>
                        {coreQuestions?.map(({name, label}) => (
                            <Grid item xs={4} key={name}>
                                <SwitchSegmentedYesNo
                                    param={{
                                        name: name,
                                        label: label,
                                        category: 'cholesterol',
                                        ...(parameters[name as keyof typeof parameters] as Parameter),
                                    }}
                                    required={''}
                                    valueChanged={valueChanged}
                                />
                            </Grid>
                        ))}
                        {parameters.Cholesterol.value && (
                            <Grid item xs={12} style={{marginTop: 10}}>
                                <Card style={{padding: 20}}>
                                    <strong>Cholesterol</strong>
                                    <Grid container spacing={3}>
                                        <Grid item xs={6}>
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <DatePicker
                                                    inputVariant="outlined"
                                                    variant="inline"
                                                    openTo="year"
                                                    views={['year', 'month']}
                                                    label={'When were you diagnosed? '}
                                                    style={{width: '100%', marginTop: 8}}
                                                    value={parameters.cholesterolDiagnosisDate?.value || null}
                                                    onChange={(date) =>
                                                        valueChanged(parameters.cholesterolDiagnosisDate, date)
                                                    }
                                                />
                                            </MuiPickersUtilsProvider>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextBox
                                                id={'cholesterolMedications'}
                                                label={
                                                    'How many medications are you currently taking to treat this condition?'
                                                }
                                                value={parameters.cholesterolMedications?.value}
                                                onChange={(value) =>
                                                    valueChanged(parameters.cholesterolMedications, value)
                                                }
                                                type="number"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <SwitchSegmentedYesNo
                                                param={{
                                                    name: 'cholesterolChecked',
                                                    label: 'Have you had your cholesterol checked within the last 12 months?',
                                                    ...parameters.cholesterolChecked,
                                                }}
                                                required={''}
                                                valueChanged={valueChanged}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextBox
                                                id={'cholesterolReading'}
                                                label={'What was your latest cholesterol reading?'}
                                                value={parameters.cholesterolReading?.value}
                                                onChange={(value) => valueChanged(parameters.cholesterolReading, value)}
                                                type="number"
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <SelectInputElement
                                                param={{
                                                    label: 'What was your latest cholesterol reading? (New)',
                                                    name: 'cholesterolReadingAlt',
                                                    options: fieldOptions.cholesterolReadingAlt.options,
                                                    ...parameters.cholesterolReadingAlt,
                                                }}
                                                required={''}
                                                valueChanged={valueChanged}
                                            />
                                        </Grid>
                                    </Grid>
                                </Card>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
});

export default Cholesterol;
